import { ConfigLoaderService } from './app-config-loader.service';

export function appInitializerFactory(env: ConfigLoaderService) {
  return () => env.initialize();
}
